// Обычные роллы (Regular Rolls)
import rollGreenAvocado from './roll-green-avocado.svg'
import rollRiceGinger from './roll-rice-ginger.svg'
import rollSalmonOrange from './roll-salmon-orange.svg'
import rollIkuraCaviar from './roll-ikura-caviar.svg'
import rollCucumber from './roll-cucumber.svg'

// Горячие роллы (HOT Rolls) - появляются в режиме HOT ROLLS
import rollHotDragon from './roll-hot-dragon.svg'
import rollHotTamago from './roll-hot-tamago.svg'

// Массив обычных роллов
export const regularRolls = [
  { id: 'green-avocado', src: rollGreenAvocado, name: 'Авокадо' },
  { id: 'rice-ginger', src: rollRiceGinger, name: 'Рис с имбирём' },
  { id: 'salmon-orange', src: rollSalmonOrange, name: 'Лосось' },
  { id: 'ikura-caviar', src: rollIkuraCaviar, name: 'Икра' },
  { id: 'cucumber', src: rollCucumber, name: 'Огурец' },
]

// Массив горячих роллов (HOT ROLLS)
export const hotRolls = [
  { id: 'hot-dragon', src: rollHotDragon, name: 'Дракон 🔥' },
  { id: 'hot-tamago', src: rollHotTamago, name: 'Тамаго 🔥' },
]

// Все роллы вместе
export const allRolls = [...regularRolls, ...hotRolls]

// Экспорт отдельных роллов
export {
  rollGreenAvocado,
  rollRiceGinger,
  rollSalmonOrange,
  rollIkuraCaviar,
  rollCucumber,
  rollHotDragon,
  rollHotTamago,
}

// Типы
export interface RollAsset {
  id: string
  src: string
  name: string
}

// Функция получения случайного обычного ролла
export function getRandomRegularRoll(): RollAsset {
  const index = Math.floor(Math.random() * regularRolls.length)
  return regularRolls[index]
}

// Функция получения случайного горячего ролла
export function getRandomHotRoll(): RollAsset {
  const index = Math.floor(Math.random() * hotRolls.length)
  return hotRolls[index]
}

// Функция получения ролла по режиму игры
export function getRandomRoll(isHotMode: boolean = false): RollAsset {
  return isHotMode ? getRandomHotRoll() : getRandomRegularRoll()
}

